export default __webpack_public_path__ + "static/media/ic_timeoff.07b235a3.svg";